<div class="loading-overlay" *ngIf="loading$ | async">
  <div class="loading-spinner"></div>
</div>
